const keys = {
    currentFeedbackTab : 'current-feedback-tab',
    encrypt_key: '896943430788438',
    hash_key: '01dce63ecb2b54fc1f0ce9604c9250ba'
};

export default keys;